<template>
    <div class="w-full @container">
        <div class="gap-4 grid grid-cols-1 @md:grid-cols-2">
            <div v-for="modification in modifications">
                <InputLabel class="ml-4 text-gray-500" :value="modification.title"/>

                <component
                  :is="modification.options.length < 4 ? 'Switch' : 'Dropdown'"
                  :options="modification.options"
                  :model-value="this.selectedOptions[modification.id].options"
                  @update:modelValue="optionId => selectModification(modification, optionId)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import InputLabel from "@/Components/InputLabel.vue";
import Switch from '@/Components/Forms/Switch.vue';
import Dropdown from '@/Components/Forms/Dropdown.vue';

export default {
    components: { Dropdown, Switch, InputLabel},
    props: {
        modifications: Array,
        selectedOptions: Object,
        variants: {
            type: Object,
            default: {}
        },
        productVariant: Object,
        defaults: Array,
    },
    emits: ['changed'],
    methods: {
        selectModification(modification, optionId) {
            this.selectedOptions[modification.id].options = [optionId]

            this.$emit('changed')
        }
    },
    created() {
        const variantOptions = this.productVariant?.slug.split('-') || [];

        this.modifications
            .forEach(modification => {
                const options = []

                modification.options.forEach(option => {
                    if (variantOptions.length) {
                        if (variantOptions.includes(option.id.toString())) {
                            options.push(option.id)
                        }

                        return;
                    }

                    if (this.defaults?.includes(option.id)) {
                        options.push(option.id)

                        return;
                    }

                    if (option.is_default || modification.options.length === 1) {
                        options.push(option.id)
                    }
                })

                if (!options.length) {
                    options.push(modification.options[0].id)
                }

                this.selectedOptions[modification.id] = {
                    modification_id: modification.id,
                    options
                }
            })
    }
}
</script>
